import React from 'react';
import { useSEOKeywords } from '../../hooks/useSEOKeywords';
import { ppData } from '../../configs/ppData.config';
import { getDynamicSEODescription } from '../../utils/getDynamicSEODescription';
const { mainCollection, mediumHandle } = ppData;
const mainCollectionTitle = mainCollection?.title;
export const InfoDescription = () => {
    const [kw1] = useSEOKeywords();
    const mkw = `${kw1}${kw1 === 'Drawing' || kw1 === 'Painting' ? 's' : ''}`;
    const description = getDynamicSEODescription(kw1);
    return React.createElement(React.Fragment, null,
        description.map((text, i) => {
            return React.createElement(React.Fragment, { key: i },
                text,
                React.createElement("br", null));
        }),
        React.createElement("br", null),
        "Looking for additional ",
        mainCollectionTitle,
        " ",
        mkw,
        " inspiration? Choose from countless ",
        React.createElement("a", { className: "text:underline", href: `${mainCollection?.url ?? ''}${mediumHandle !== null ? `/${mediumHandle.replace(/-medium|-wall-art/, '')}` : ''}` },
            mainCollectionTitle,
            " ",
            mkw),
        ", including our ",
        mainCollectionTitle,
        " multi panel canvas, framed canvas and ",
        mainCollectionTitle,
        " framed prints. The possibilities are endless with our vast selection of canvas prints.");
};
